module.exports = __webpack_public_path__ + "static/media/share.bb90d17c.svg";